import { FunctionComponent } from 'react';
import { VGDisclaimerFooter } from '../../../components/VGDisclaimerFooter/VGDisclaimerFooter';
import { trackDisclaimerModalOpen } from '../../../analytics/event-tracking/trackDisclaimerModalOpen';
import { useStreetPageModalContext } from '../../contexts/StreetPageModalContext/StreetPageModalContext';
import { styled } from 'styled-components';

const Wrapper = styled.div`
  margin: 0 auto;
  max-width: 850px;
  width: 100%;
`;

export const StreetPageVGDisclaimerFooter: FunctionComponent = () => {
  const { displayModal } = useStreetPageModalContext();

  return (
    <Wrapper>
      <VGDisclaimerFooter
        onDisclaimerLinkClick={() => {
          displayModal({ name: 'vgDisclaimer' });
          trackDisclaimerModalOpen({
            inPageSource: ['street_page', 'footer_disclaimer', 'button'].join('__'),
          });
        }}
      />
    </Wrapper>
  );
};
